
import { defineComponent, computed } from 'vue'

export default defineComponent({
    setup () {
        const messageList = computed(() => window.vueMessagesStore.getMessageList())
        const removeMessage = window.vueMessagesStore.removeMessage

        return {
            messageList,
            removeMessage,
        }
    },
})
